// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Link, useParams } from "react-router-dom";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Images
import EmptyLayout from "views/layouts/EmptyLayout";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import { useReactToPrint } from "react-to-print";

import InvoiceInfoLine from "components/InvoiceComponents/InvoiceInfoLine";
import InvoiceInfoHeader from "components/InvoiceComponents/InvoiceInfoHeader";
import InvoiceTable from "components/InvoiceComponents/InvoiceTable";
import InvoiceVatInfo from "components/InvoiceComponents/InvoiceVatInfo";
import QRCode from "react-qr-code";
import { useRef } from "react";
import Constants from "utils/Constants";
import InvoicePOSInfo from "components/InvoiceComponents/InvicePOSInfo";
import Helpers from "utils/Helpers";
import _ from "lodash";
import moment from "moment";
import { SyncLoader } from "react-spinners";
import Swal from "sweetalert2";

function InvoiceView() {
  const cardRef = useRef(null);
  const [issuerName, setIssuerName] = useState("");
  const [issuerVat, setIssuerVat] = useState("");
  const [issuerAddress, setIssuerAddress] = useState("");
  const [issuerCity, setIssuerCity] = useState("");
  const [issuerZipCode, setIssuerZipCode] = useState("");
  const [issuerGemiNumber, setIssuesGemiNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerVat, setCustomerVat] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerCity, setCustomerCity] = useState("");
  const [customerZipCode, setCustomerZipCode] = useState("");
  const [customerBranchNumber, setCustomerBranchNumber] = useState(0);
  const [invoiceType, setInvoiceType] = useState("");
  const [invoiceSeira, setInvoiceSeira] = useState("");
  const [authCode, setAuthCode] = useState("");
  const [mark, setMark] = useState("");
  const [mydataQrUrl, setMydataQrUrl] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoicePaymentMethod, setInvoicePaymentMethod] = useState("");
  const [invoiceMovementType, setInvoiceMovementType] = useState("");
  const [invoiceWithheldAmount, setInvoiceWithheldAmount] = useState(0);
  const [invoiceFeesAmount, setInvoiceFeesAmount] = useState(0);
  const [invoiceVatAmount, setInvoiceVatAmount] = useState(0);
  const [invoiceNetAmount, setInveoiceNetAmount] = useState(0);
  const [invoiceGrossAmount, setInvoiceGrossAmount] = useState(0);
  const [invoiceTransmissionFailure, setInvoiceTransmissionFailure] = useState("");
  const [invoiceSelfPricing, setInvoiceSelftPricing] = useState(false);
  const [paymnet, setPayment] = useState(null);

  const [invoiceLines, setInvoiceLines] = useState([]);
  const [showInvoice, setShowInvoice] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(true);

  const borderInfo = `2px solid white`;

  const { uid } = useParams();

  const fetchInvoiceInfo = async () => {
    const response = await ApiService.getData(`/api/v1/invoices/view-invoice/${uid}`, {});
    setLoadingInvoice(false);
    if (!response) {
      Swal.fire({
        icon: "error",
        title: "Αποτυχία!",
        text: "Αδυναμία έρευσης παραστατικού. Δοκιμάστε ξανά αργότερα.",
      }).then((result) => {
        window.location.reload();
      });
      return;
    }
    setInvoiceLines(_.get(response, "data.request.invoiceDetails", []));
    setIssuerName(_.get(response, "data.request.issuer.name"));
    setIssuerVat(_.get(response, "data.request.issuer.vatNumber"));
    const address =
      _.get(response, "data.request.issuer.address.street") +
      _.get(response, "data.request.issuer.address.number");
    setIssuerAddress(address);
    setIssuerCity(_.get(response, "data.request.issuer.address.city"));
    setIssuerZipCode(_.get(response, "data.request.issuer.address.postalCode"));
    setIssuesGemiNumber(_.get(response, "data.request.issuer.gemiNumber"));

    setCustomerName(_.get(response, "data.counterpartName"));
    setCustomerVat(_.get(response, "data.request.counterpart.vatNumber"));
    let counterPartAddress = "";
    const counterPartStreet = _.get(response, "data.request.counterpart.address.street");

    if (counterPartStreet)
      counterPartAddress = `${counterPartStreet} ${_.get(
        response,
        "data.request.counterpart.address.number"
      )}`;
    setCustomerAddress(counterPartAddress);
    setCustomerCity(_.get(response, "data.request.counterpart.address.city"));
    setCustomerZipCode(_.get(response, "data.request.counterpart.address.postalCode"));
    setCustomerBranchNumber(_.get(response, "data.request.counterpart.branch"));

    setInvoiceType(_.get(response, "data.request.invoiceHeader.invoiceTypeDescription"));
    setInvoiceSeira(_.get(response, "data.request.invoiceHeader.series"));
    setInvoiceNumber(_.get(response, "data.request.invoiceHeader.aa"));
    const requestDate = _.get(response, "data.request.requestDate");
    const reqMoment = moment(requestDate);
    setInvoiceDate(reqMoment.format("DD/MM/YYYY HH:mm"));
    setInvoiceSelftPricing(_.get(response, "data.request.invoiceHeader.selfPricing", false));

    setInvoicePaymentMethod(
      _.get(response, "data.request.paymentMethods.paymentMethodDetails[0].typeDescription")
    );
    if (response.data.payment && _.get(response, "data.payment.status") === "COMPLETED") {
      setInvoicePaymentMethod("POS");
    }

    setInvoiceMovementType(_.get(response, "data.request.invoiceHeader.movePurpose"));

    setInvoiceWithheldAmount(_.get(response, "data.request.invoiceSummary.totalWithheldAmount"));
    setInvoiceFeesAmount(_.get(response, "data.request.invoiceSummary.totalFeesAmount"));
    setInvoiceVatAmount(_.get(response, "data.request.invoiceSummary.totalVatAmount"));
    setInveoiceNetAmount(_.get(response, "data.request.invoiceSummary.totalNetValue"));
    setInvoiceGrossAmount(_.get(response, "data.request.invoiceSummary.totalGrossValue"));

    setAuthCode(_.get(response, "data.response.authenticationCode"));
    setMark(_.get(response, "data.response.invoiceMark"));
    setMydataQrUrl(_.get(response, "data.response.myDataQrUrl"));
    let transmissionFailure = _.get(
      response,
      "data.request.transmissionFailure",
      Constants.NO_TRANSMISSION_FAILURE_TEXT
    );
    if (transmissionFailure === 1) transmissionFailure = Constants.TRANSMISSION_FAILURE_1_TEXT;
    if (transmissionFailure === 2)
      transmissionFailure = transmissionFailure = Constants.TRANSMISSION_FAILURE_2_TEXT;
    setInvoiceTransmissionFailure(transmissionFailure);

    setPayment(response.data.payment);
    setShowInvoice(true);
  };

  const handlePrint = useReactToPrint({
    contentRef: cardRef,
    documentTitle: `invoice_${uid}`,
  });

  const handleShowMydata = () => {
    if (mydataQrUrl !== null) window.open(mydataQrUrl);
  };

  useEffect(() => {
    fetchInvoiceInfo();
  }, []);

  return (
    <EmptyLayout>
      <SoftBox>
        {loadingInvoice ? (
          <Grid container justifyContent="center" style={{ marginTop: "30%" }}>
            <SyncLoader loading={loadingInvoice} margin={10} color="#17c1e8"></SyncLoader>
          </Grid>
        ) : (
          <> </>
        )}
        {showInvoice ? (
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={8}>
              <Card id="invoice-card" ref={cardRef}>
                <SoftBox p={1}>
                  <Grid container>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceInfoHeader title={"Στοιχεία Εκδότη"} />
                      <InvoiceInfoLine title={"Επωνυμία:"} text={issuerName} />
                      <InvoiceInfoLine title={"ΑΦΜ:"} text={issuerVat} />
                      <InvoiceInfoLine title={"Διεύθυνση:"} text={issuerAddress} />
                      <InvoiceInfoLine title={"Πόλη:"} text={issuerCity} />
                      <InvoiceInfoLine title={"ΤΚ:"} text={issuerZipCode} />
                      <InvoiceInfoLine title={"ΑΡ. ΓΕΜΗ:"} text={issuerGemiNumber} />
                    </Grid>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceInfoHeader title={"Στοιχεία Πελάτη"} />
                      <InvoiceInfoLine title={"Επωνυμία:"} text={customerName} />
                      <InvoiceInfoLine title={"ΑΦΜ:"} text={customerVat} />
                      <InvoiceInfoLine title={"Διεύθυνση:"} text={customerAddress} />
                      <InvoiceInfoLine title={"Πόλη:"} text={customerCity} />
                      <InvoiceInfoLine title={"ΤΚ:"} text={customerZipCode} />
                      {customerBranchNumber > 0 ? (
                        <InvoiceInfoLine title={"Υποκατάστημα:"} text={customerBranchNumber} />
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceInfoHeader title={"Στοιχεία Παραστατικού"} />
                      <InvoiceInfoLine title={"Τύπος:"} text={invoiceType} />
                      <InvoiceInfoLine title={"Σειρά:"} text={invoiceSeira} />
                      <InvoiceInfoLine title={"Αριθμός:"} text={invoiceNumber} />
                      <InvoiceInfoLine title={"Ημερ/νία:"} text={invoiceDate} />
                      <InvoiceInfoLine title={"Πληρωμή:"} text={invoicePaymentMethod} />
                      <InvoiceInfoLine title={"Σκ. Διακίνησης:"} text={invoiceMovementType} />
                      <InvoiceInfoLine title={"Διαβίβαση:"} text={invoiceTransmissionFailure} />
                      {invoiceSelfPricing ? (
                        <InvoiceInfoLine title={"Αυτοτιμολόγηση:"} text="ΝΑΙ" />
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceInfoHeader title={"MyDATA"} />
                      <InvoiceInfoLine title={"Μ.ΑΡ.Κ.:"} text={mark} />
                      <InvoiceInfoLine title={"UID:"} text={uid} fontSize={"8pt"} />
                      <InvoiceInfoLine title={"Auth Code:"} text={authCode} fontSize={"8pt"} />

                      <SoftBox
                        width="100%"
                        display="flex"
                        flexDirection={{ xs: "row", md: "row" }}
                        alignItems={{ xs: "flex-start", md: "center" }}
                        textAlign={{ xs: "left", md: "right" }}
                        mt={{ xs: 0, md: 0 }}
                      >
                        <SoftBox width="10%">
                          <SoftTypography
                            variant="h6"
                            color="secondary"
                            fontWeight="medium"
                            textAlign={"left"}
                            fontSize={"8pt"}
                          >
                            QR:
                          </SoftTypography>
                        </SoftBox>
                        <SoftBox width="70%" textAlign={"center"}>
                          <QRCode
                            size={64}
                            value={Helpers.BASE_URL + "/view-invoice/" + uid}
                            viewBox={`0 0 64 64`}
                          />
                        </SoftBox>
                      </SoftBox>
                    </Grid>
                  </Grid>
                </SoftBox>

                <SoftBox p={1}>
                  <InvoiceInfoHeader title={"Ανάλυση"} />
                  <InvoiceTable lines={invoiceLines} withheldAmount={invoiceWithheldAmount} />
                </SoftBox>

                <SoftBox p={1}>
                  <Grid container>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceVatInfo data={invoiceLines} />
                    </Grid>
                    <Grid item xs={12} sm={6} border={borderInfo}>
                      <InvoiceInfoHeader title={"Ανάλυση Ποσών"} />
                      <InvoiceInfoLine title={"Νόμισμα:"} text={"EUR"} />
                      {invoiceWithheldAmount > 0 ? (
                        <InvoiceInfoLine
                          title={"Παρακράτηση:"}
                          text={invoiceWithheldAmount.toFixed(2)}
                        />
                      ) : (
                        ""
                      )}
                      {invoiceFeesAmount > 0 ? (
                        <InvoiceInfoLine title={"Τέλη:"} text={invoiceFeesAmount.toFixed(2)} />
                      ) : (
                        ""
                      )}
                      <InvoiceInfoLine title={"Καθαρό:"} text={invoiceNetAmount.toFixed(2)} />
                      <InvoiceInfoLine title={"Φ.Π.Α:"} text={invoiceVatAmount.toFixed(2)} />
                      <InvoiceInfoLine
                        title={"Πληρωτέο:"}
                        text={invoiceGrossAmount.toFixed(2)}
                        fontSize={"14pt"}
                        color={"black"}
                        fontWeight={"bolder"}
                      />
                    </Grid>
                  </Grid>
                </SoftBox>

                <InvoicePOSInfo payment={paymnet} />

                <SoftBox p={1}>
                  <SoftTypography
                    variant="h6"
                    color="secondary"
                    fontWeight="medium"
                    textAlign={"center"}
                    fontSize={"8pt"}
                  >
                    Πάροχος: Galex Ε.Ε. | Domain παρόχου: https://www.eparoxos.gr | Άδεια
                    Καταλληλότητας (ΥΠΑΗΕΣ): {process.env.REACT_APP_PROVIDER_LICENSE}
                  </SoftTypography>
                </SoftBox>
              </Card>
              <SoftBox p={3} mt={7}>
                <Grid container>
                  <Grid item xs={12}>
                    <SoftBox
                      width="100%"
                      height={{ xs: "auto", md: "100%" }}
                      display="flex"
                      justifyContent={"center"}
                      alignItems="flex-end"
                      m={{ xs: 0, md: 0 }}
                    >
                      <SoftButton
                        variant="gradient"
                        color="warning"
                        style={{ margin: "1%", width: "40%" }}
                        onClick={() => handlePrint()}
                      >
                        ΕΚΤΥΠΩΣΗ
                      </SoftButton>
                      <SoftButton
                        variant="gradient"
                        color="info"
                        style={{ margin: "1%", width: "40%" }}
                        onClick={handleShowMydata}
                      >
                        myDATA
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </Grid>
              </SoftBox>
            </Grid>
          </Grid>
        ) : (
          <> </>
        )}
      </SoftBox>
    </EmptyLayout>
  );
}

export default InvoiceView;
